import React from 'react';
import { AlertTriangle, RefreshCw, HardDrive } from 'lucide-react';
import { useScrollReveal } from '@/lib/useScrollReveal';

const painPoints = [
  {
    icon: RefreshCw,
    title: 'Agents start each session from scratch — expensive re-contextualization is the norm',
  },
  {
    icon: AlertTriangle,
    title: 'Provider lock-in means your memory dies if you switch from Claude to GPT',
  },
  {
    icon: HardDrive,
    title: 'Custom Redis hacks are brittle, require DevOps, and offer no standardization',
  },
];

export const ProblemSection: React.FC = () => {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>();

  return (
    <section className="py-20 bg-surface-secondary" ref={ref}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          className={`text-center mb-16 transition-all duration-500 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-text-primary mb-4">
            AI Agents Forget Everything.{' '}
            <span className="text-danger">Every. Single. Session.</span>
          </h2>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto">
            The current state of agent memory is broken.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {painPoints.map((pain, index) => (
            <div
              key={pain.title}
              className={`bg-white border-l-4 border-danger p-6 rounded-lg shadow-sm transition-all duration-500 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
              style={{ transitionDelay: `${(index + 1) * 100}ms` }}
            >
              <pain.icon className="w-8 h-8 text-danger mb-4" />
              <p className="text-lg font-medium text-text-primary leading-relaxed">
                {pain.title}
              </p>
            </div>
          ))}
        </div>

        <div
          className={`text-center transition-all duration-500 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
          style={{ transitionDelay: '400ms' }}
        >
          <p className="text-xl text-text-primary font-medium">
            Agent Memory Gateway gives your agents the memory infrastructure they deserve.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;